"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const Card_1 = __importDefault(require("../../atoms/Card"));
const react_1 = require("react");
function SearchField(props) {
    const { onChange, className } = props;
    const { t } = (0, i18n_1.useTranslation)();
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const onChangeValue = (event) => {
        const newValue = event.target.value;
        setSearchValue(newValue);
        onChange(newValue);
    };
    const onClearSearch = () => {
        setSearchValue('');
        onChange('');
    };
    return ((0, jsx_runtime_1.jsx)(Card_1.default, { className: className, children: (0, jsx_runtime_1.jsx)(ui_1.SearchContainer, { onChange: onChangeValue, onClear: onClearSearch, value: searchValue, placeholder: t(i18n_1.Strings.search.placeholderGrasshopper) }) }));
}
exports.default = SearchField;
